import { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { Alert, Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, Row } from 'reactstrap';
import { IUser } from 'src/services/types';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { updateUser } from 'src/services/users-service';

interface IProps {
    show: boolean;
    onClose: () => void;
    item: IUser;
    onRefresh: () => void;
} 
export const NoteModal = ({ show, onClose, item, onRefresh }: IProps) => {
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const formik = useFormik({
        enableReinitialize: true,

        initialValues: {
            note: item?.note || '',
        },
        validationSchema: Yup.object().shape({
            note: Yup.string().optional().max(500, "Note must be less than 500 characters"),
        }),
        onSubmit: (values) => {
            onUpdateNote(values?.note);
        }
    });

    const onUpdateNote = async (note: string)=> {
        setLoading(true);
        setErrorMessage('');
        const res = await updateUser(item?.id, { note });
        setLoading(false);
        if (res.result === 'ok') {
            toast( item?.note ? 'Note updated successfully' : 'Note added successfully', { type: 'success', autoClose: 3000});
            onRefresh();
            onClose();
        } else {
            setErrorMessage(res.message);
            console.log('error:', res.message);
        }
    }

    useEffect(() => {
        if(show) {
            formik.resetForm();
        }
    }, [show]);

  return (
    <Modal
        isOpen={show}
        backdrop={"static"}
        id="staticBackdrop"
        className=''
    >
        {
            <div style={{position: 'relative', backgroundColor: loading ? '#D8C8B8' : '#fff' }}>
                <div className="modal-header">
                    <h5 className="modal-title" id="staticBackdropLabel">
                        {item?.note ? 'Update Note' : 'Add Note'}
                    </h5>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={onClose}
                        aria-label="Close"
                    ></button>
                </div>
                <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            formik.handleSubmit();
                            return false;
                        }}
                >
                    <div className="modal-body">
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="note">Note</Label>
                                    <Input
                                        name="note"
                                        placeholder="Enter a note..."
                                        type="textarea"
                                        className="form-control"
                                        id="note"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.note || ""}
                                        invalid={
                                            formik.touched.note && formik.errors.note ? true : false
                                        }
                                        style={{ backgroundColor: '#fff' }}
                                    />
                                    {formik.touched.note && formik.errors.note ? (
                                        <FormFeedback type="invalid">{formik.errors.note}</FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Alert color="danger" isOpen={errorMessage !== ''} toggle={() => setErrorMessage('')}>
                                {errorMessage}
                            </Alert>
                        </Row>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            Close
                        </button>
                        
                        <Button color="primary" type="submit" className='waves-effect waves-light'>
                                {item?.note ? 'Update' : 'Add'} Note
                        </Button>
                    </div>
                </Form>
                {
                    loading ? 
                    <div 
                        className='d-flex justify-content-center align-items-center rounded my-2 mx-2' 
                        style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(253, 252, 255, 0.75)'}}
                    >
                         <div className="spinner-border text-primary" role="status">
                        </div>
                        <span className="text-primary fs-5 mx-2">
                            {item?.note ? 'Updating note...' : 'Adding note...'}
                        </span>
                    </div>
                    : null
                }
            </div>   
        }
    </Modal>
  )
}
